import type {QueryClient} from '@tanstack/react-query';
/** Confirmation belongs to this cabinet, exact selection, and template. */
export function bulkScope(base:string,ids:readonly string[],total:number,template:string){
 return JSON.stringify([base,[...new Set(ids)].sort(),total,template]);
}
export async function refreshBulkCampaigns(qc:QueryClient){
 await Promise.all(['campaigns','overview','holds','features','schedule','topup','stop-rules','why-quiet'].map(name=>qc.invalidateQueries({queryKey:[name]})));
}
